import { Container, Grid, Paper } from "@mui/material";
import OrganizationUsers from "../logic/OrganizationUsers";

export default function DashboardPage() {
	return (
		<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
			<Grid container spacing={3}>
				{/* Users within the selected organization grid */}
				<Grid item xs={12}>
					<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
						<OrganizationUsers />
					</Paper>
				</Grid>
			</Grid>
		</Container>
	);
}
